import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import Clips from '../../routes/clips';
import Root from '../../routes/root';
import Videos from '../../routes/videos';

import styles from './App.module.scss';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/clips/:tourId/portrait',
    element: <Clips videoId="portrait" />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/clips/:tourId/landscape',
    element: <Clips videoId="landscape" />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/videos/:tourId/:videoId',
    element: <Videos />,
    errorElement: <ErrorBoundary />,
  },
]);

export default function App() {
  return (
    <div className={styles.app}>
      <RouterProvider router={router} />
    </div>
  );
}
